@if (hasTabs) {
  <section [class.h-full]="stretchVertically">
    <div class="tabs relative z-10 gap-3" [class.h-full]="stretchVertically">
      @if (useCarousel) {
        <app-carousel [carouselMaxWidthInPercents]="carouselMaxWidthInPercents">
          @for (tab of tabs; track tabTrackBy(i, tab); let i = $index) {
            <ng-container *carouselItem>
              <ng-container *ngTemplateOutlet="tabOptionContent; context: { tab, i }"></ng-container>
            </ng-container>
          }
        </app-carousel>
      } @else {
        @for (tab of tabs; track tabTrackBy(i, tab); let i = $index) {
          <ng-container *ngTemplateOutlet="tabOptionContent; context: { tab, i }"></ng-container>
        }
      }
    </div>
    @if (isShowBottomBorder) {
      <div class="border-bottom mt-px" [class.no-paddings-border]="noPadingBorderButton"></div>
    }
  </section>
}

<ng-template #tabOptionContent let-tab="tab" let-i="i">
  @if (isTabDisplayed(tab)) {
    @if (tab.routerLink) {
      <span [routerLink]="isTabDisabled(tab) ? null : tab.routerLink">
        <ng-container *ngTemplateOutlet="tabOption"></ng-container>
      </span>
    } @else {
      <div [ngbTooltip]="getTabToolTipKey(tab) | translate" [placement]="tab.toolTipPlacement ?? 'left'">
        <app-tab-option
          [attr.data-test-id]="tab.tabId"
          [class.adaptive-width]="hasAdaptiveWidth"
          [class.h-full]="stretchVertically"
          [class.disabled]="isTabDisabled(tab)"
          [disabled]="isTabDisabled(tab)"
          [size]="tabSize"
          [selected]="i === selectedTabIndex"
          [count]="tab.count"
          [hideCounterOnZero]="tab.hideCounterOnZero"
          [progress]="tab.progress"
          [progressColor]="tab.progressColor"
          [svgIconPath]="tab.icon"
          (click)="!isTabDisabled(tab) && selectTab(i, true)"
        >
          {{ tab.translationKey | translate: tab.translationKeyParams }}
        </app-tab-option>
      </div>
    }
  }

  <ng-template #tabOption>
    <div [ngbTooltip]="getTabToolTipKey(tab) | translate" [placement]="tab.toolTipPlacement ?? 'left'">
      <app-tab-option
        [attr.data-test-id]="tab.tabId"
        [class.adaptive-width]="hasAdaptiveWidth"
        [class.h-full]="stretchVertically"
        [class.disabled]="isTabDisabled(tab)"
        [disabled]="isTabDisabled(tab)"
        [size]="tabSize"
        [selected]="i === selectedTabIndex"
        [count]="tab.count"
        [hideCounterOnZero]="tab.hideCounterOnZero"
        [progress]="tab.progress"
        [progressColor]="tab.progressColor"
        [svgIconPath]="tab.icon"
        (click)="!isTabDisabled(tab) && selectTab(i, true)"
      >
        {{ tab.translationKey | translate: tab.translationKeyParams }}
      </app-tab-option>
    </div>
  </ng-template>
</ng-template>

@if (allowTabTemplates && hasTabs) {
  <section class="content flex-1">
    @for (tab of tabs; track tab; let i = $index) {
      @if (renderAllTabs || i === selectedTabIndex) {
        <div class="tab-content" [ngClass]="{ 'w-0 h-0 overflow-hidden opacity-0': i !== selectedTabIndex }">
          <ng-container *ngTemplateOutlet="tab.tabTemplate; context: tab.context"></ng-container>
        </div>
      }
    }
  </section>
}
